import type { Address } from '@/references/base';

import { isBaseAssetByNetwork, Network } from './network';

export type Token = {
  address: Address;
  decimals: number;
  symbol: string;
  network: Network;
  name: string;
  iconURL: string;
};

export type PermitData = {
  hasPermit: boolean;
  permitVersion?: string;
  permitType?: string;
};

export type TokenWithPrice = Token & {
  priceUSD: string;
  priceChange: number;
};

export type TokenWithEurPrice = Token & {
  priceEUR: string;
  priceChange: number;
};

export type TokenWithBalance = Token & {
  balance: string;
};

export type TokenWithPriceAndBalance = TokenWithBalance & TokenWithPrice;

export const isTokenHasPermitData = (
  token: TokenWithBalance | (TokenWithBalance & PermitData)
): token is TokenWithBalance & PermitData => {
  return 'hasPermit' in token && token.hasPermit !== undefined;
};

export const substituteAssetAddressIfNeeded = (address: Address, network: Network): Address => {
  if (isBaseAssetByNetwork(address, network)) {
    return '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE';
  }

  return address;
};
